import React, { useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import { useIntl } from 'react-intl';
import { useCookies } from 'react-cookie';
import { uiColors } from '../../common/styles';
import { rejectCookies, acceptCookies } from '../../data/gtm';
import { useTracking } from '../../data/gtm';
import { useAuth, useModal, useNavigation } from '../../context';
import { setCookie } from '../../utilities/helpers';
import { VIDEO_SCREEN } from '../../providers/NavigationProvider';

const CookiesSettings = () => {
    const { user } = useAuth();
    const intl = useIntl();
    const [cookies] = useCookies(['CookieConsent', 'cookieconsent_status', 'cookieconsent_status_marketing', , 'cookieconsent_status_analytics']);
    const { modal, openModal } = useModal();
    const { pushEvent } = useTracking();
    const { activeDrawer } = useNavigation();

    useEffect(() => {
        if (cookies.CookieConsent === undefined && !cookies.cookieconsent_status && activeDrawer !== VIDEO_SCREEN && modal?.type !== 'cookies' && modal?.type !=='welcomeScreen') {
            console.log('CookiesSettings', cookies, activeDrawer, modal);
            pushEvent('cookie_consent_display');
            openModal('cookies');
            rejectCookies();
            if (cookies.cookieconsent_status) {
                acceptCookies({ marketing: cookies.cookieconsent_status_marketing === 'allow', analytics: cookies.cookieconsent_status_analytics === 'allow' });
                setCookie('CookieConsent', true, 365);
            }
        }
    }, [cookies, activeDrawer, modal]);


    return null;
};

export default CookiesSettings;
